import { giphyDarkestGrey } from '@giphy/js-brand'
import { useContext } from 'react'
import styled, { css } from 'styled-components'
import { BUTTON_ACTIVE_OPACITY } from '../../constants'
import CreationToolStatus from '../../types/status'
import { CreationToolUploadContext } from './manager'
import UploadButton from './upload-button'

const Container = styled.div`
    background: ${giphyDarkestGrey};
    bottom: 0;
    margin: 0 -20px;
    padding-bottom: 10px;
    position: sticky;
    z-index: 1;
    text-align: center;
`

const DownloadButton = styled.div<{ disabled?: boolean }>`
    cursor: pointer;
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin: 20px auto;

    &:active {
        opacity: ${BUTTON_ACTIVE_OPACITY};
    }

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`

const CreationUploadButtons = () => {
    const { download, allowDownload, status } = useContext(CreationToolUploadContext)
    const isIdle = status === CreationToolStatus.Idle
    return (
        <Container>
            <UploadButton />
            {allowDownload && (
                <DownloadButton disabled={!isIdle} onClick={download}>
                    Download
                </DownloadButton>
            )}
        </Container>
    )
}

export default CreationUploadButtons
